// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4548":"c38fef53","12752":"32c7629d","31954":"82ba7da3","32622":"32c7629d","42396":"80b81a22","44721":"32c7629d"}[chunkId] + ".chunk.css";
};